export const three = [
  {
    name: "E-Commerce Store",
    img: "store-shop.png",
    url: "https://axelreid-store.netlify.app",
    varID: 0.1,
    note: "not ready",
  },
  {
    name: "Shopping cart",
    img: "shopping-cart.jpg",
    url: "http://axel-react-project-shopping-cart.netlify.app",
    varID: 0.3,
  },
];

export const projects = [
  {
    id: 1,
    name: "My talking tom",
    url: "http://axel-js-project-mytalkingtom.netlify.app",
    img: "shopping-cart.png",
    sort: 1,
    tech: ["html", "css", "js"],
  },
  {
    id: 1.5,
    name: "Portfolio",
    img: "portfolio.png",
    url: "http://axel-html-css-js-portfolio.netlify.app",
    sort: 1,
    tech: ["html", "css", "js"],
  },
  {
    id: 2,
    name: "Filter Menu",
    url: "http://axel-js-project-filter-menu.netlify.app",
    img: "filter.png",
    sort: 3,
    tech: ["html", "css", "js"],
  },
  {
    id: 3,
    name: "RPS Game",
    url: "http://axel-js-project-rps-game.netlify.app",
    img: "rps-game.png",
    sort: 2,
    tech: ["html", "css", "js"],
  },
  {
    id: 3.25,
    name: "E-Commerce Store",
    img: "store-shop.png",
    url: "https://axelreid-store.netlify.app",
    sort: 1,
    tech: ["html", "js", "scss"],
  },
  {
    id: 3.5,
    name: "Shopping cart",
    img: "shopping-cart.jpg",
    url: "http://axel-react-project-shopping-cart.netlify.app",
    sort: 1,
    tech: ["react-js"],
  },
  {
    id: 4,
    name: "Numbers Fight",
    url: "http://axel-js-project-numbers-fight.netlify.app",
    img: "numbers-fight.png",
    sort: 2,
    tech: ["html", "css", "js"],
  },
  {
    id: 5,
    name: "Todolist-1",
    url: "http://axel-js-project-todolist-one.netlify.app",
    img: "todo-list.png",
    sort: 3,
    tech: ["html", "css", "js"],
  },
  {
    id: 5.5,
    name: "Pie-Chart",
    url: "https://axel-react-chart-project.netlify.app",
    img: "pie-chart.png",
    sort: 3,
    tech: ["react-js"],
  },
  {
    id: 6,
    name: "Todolist-2",
    url: "http://axel-js-project-todolist-two.netlify.app",
    img: "todolist-2.jpg",
    sort: 3,
    tech: ["html", "css", "js"],
  },
  {
    id: 6.5,
    name: "Puzzle Game",
    url: "https://axelreid-game-puzzle.netlify.app",
    img: "puzzle.png",
    sort: 2,
    tech: ["html", "css", "js", "jquery"],
  },
  {
    id: 7,
    name: "Chat with bot",
    url: "http://axel-js-project-chatwithbot.netlify.app",
    img: "chat-app.jpg",
    sort: 3,
    tech: ["html", "css", "js"],
  },
  {
    id: 7.5,
    name: "Quiz Game",
    url: "https://axelreid-game-aq.netlify.app",
    img: "word-game.png",
    sort: 2,
    tech: ["html", "css", "js"],
  },
  {
    id: 8,
    name: "Clock UI",
    url: "http://axel-js-project-clock-ui.netlify.app",
    img: "clock-ui.png",
    sort: 3,
    tech: ["html", "css", "js"],
  },
  {
    id: 9,
    name: "Progress Bar",
    url: "http://axel-js-project-progress-bar.netlify.app",
    img: "progress.png",
    sort: 3,
    tech: ["html", "css", "js"],
  },
  {
    id: 10,
    name: "Accordion",
    url: "http://axel-js-project-accordion.netlify.app",
    img: "accordion.jpg",
    sort: 3,
    tech: ["html", "css", "js"],
  },
  {
    id: 11,
    name: "Countdown",
    url: "http://axel-js-project-countdown.netlify.app",
    img: "countdown.png",
    sort: 3,
    tech: ["html", "css", "js"],
  },
  {
    id: 12,
    name: "Canvas",
    url: "http://axel-js-project-canvas.netlify.app",
    img: "canvas-magic.png",
    sort: 3,
    tech: ["html", "css", "js"],
  },
  {
    id: 13,
    name: "Quiz Game",
    url: "http://axel-js-project-quiz-app.netlify.app",
    img: "quiz-app.png",
    sort: 2,
    tech: ["html", "css", "js"],
  },
];
